import script from "./save-forecast-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./save-forecast-modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__